import React from "react";

import { useCurrentProjectContext } from "@v2/contexts/CurrentProjectContext";

import { LoadedSettings, SettingsLayout } from "../SettingsCard";
import {
  CustomDomainsSection,
  GroupNamesSection,
} from "./experiments-settings-sections";

const AbTestingWrapper = () => {
  const { project } = useCurrentProjectContext();

  if (!project) {
    return null;
  }

  const sections = [
    {
      title: "Custom Domains",
      description:
        "To use a custom domain instead of reploedge, just set it up with your domain provider.",
      component: <CustomDomainsSection />,
    },
    {
      title: "Group Names",
      description:
        "If you're using the reploedge.com domain, your Group Name will be added to links as: reploedge.com/GroupName.",
      component: <GroupNamesSection />,
    },
  ];

  return (
    <SettingsLayout>
      <LoadedSettings sections={sections} />
    </SettingsLayout>
  );
};

export default AbTestingWrapper;
